import { t, TOptions } from '@if/core/i18n'

/**
 * @deprecated for comaptibility reason only. use hook or import "t" directly from i18n pour les messages éphémère (no refresh on lang change)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translate = (key: any, params?: TOptions): string => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return t(key, params)
}

export default translate
